export const ATTRIBUTE_TYPES_REQUEST = "AttributeTypes.Request";
export const ATTRIBUTE_TYPES_SUCCESS = "AttributeTypes.Success";
export const ATTRIBUTE_TYPES_FAILURE = "AttributeTypes.Failure";
export const ATTRIBUTE_TYPES_RESET = "AttributeTypes.Reset";


export function getAttributeTypes() {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: ATTRIBUTE_TYPES_REQUEST });
    return fetch(`/api/attribute-types/`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: ATTRIBUTE_TYPES_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: ATTRIBUTE_TYPES_FAILURE, payload: data });
      }
    });
  };
}

// -----------------------------------------------------------------------


export const ATTRIBUTES_REQUEST = "Attributes.Request";
export const ATTRIBUTES_SUCCESS = "Attributes.Success";
export const ATTRIBUTES_FAILURE = "Attributes.Failure";
export const ATTRIBUTES_RESET = "Attributes.Reset";


export function getAttributes(data) {
  return (dispatch, getState) => {
    const { auth } = getState();
    const params = data || {};
    dispatch({ type: ATTRIBUTES_REQUEST });
    const queryParams = new URLSearchParams({
      page: params.page ?? 0,    
      limit: params.limit ?? 60
    }).toString();

    return fetch(`/api/attributes/?${queryParams}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: ATTRIBUTES_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: ATTRIBUTES_FAILURE, payload: data });
      }
    });
  };
}


// -----------------------------------------------------------------------


export const ATTRIBUTES_POST_REQUEST = "AttributesPost.Request";
export const ATTRIBUTES_POST_SUCCESS = "AttributesPost.Success";
export const ATTRIBUTES_POST_FAILURE = "AttributesPost.Failure";
export const ATTRIBUTES_POST_RESET = "AttributesPost.Reset";

export function addAttributes(data) {

  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: ATTRIBUTES_POST_REQUEST });
    return fetch(`/api/attributes/`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: ATTRIBUTES_POST_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: ATTRIBUTES_POST_FAILURE, payload: data });
      }
    });
  };
}
// ------------------------
export const ATTRIBUTE_EDIT_REQUEST = "AttributeEdit.Request";
export const ATTRIBUTE_EDIT_SUCCESS = "AttributeEdit.Success";
export const ATTRIBUTE_EDIT_FAILURE = "AttributeEdit.Failure";
export const ATTRIBUTE_EDIT_RESET = "AttributeEdit.Reset";

export function editAttribute(data:any, id:string) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: ATTRIBUTE_EDIT_REQUEST });
    return fetch(`/api/attributes/${id}`, {
      method: "PATCH",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: ATTRIBUTE_EDIT_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: ATTRIBUTE_EDIT_FAILURE, payload: data });
      }
    });
  };
}
// ------------------------
export const ATTRIBUTE_DELETE_REQUEST = "AttributeDelete.Request";
export const ATTRIBUTE_DELETE_SUCCESS = "AttributeDelete.Success";
export const ATTRIBUTE_DELETE_FAILURE = "AttributeDelete.Failure";
export const ATTRIBUTE_DELETE_RESET = "AttributeDelete.Reset";

export function deleteAttribute( id:string) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: ATTRIBUTE_EDIT_REQUEST });
    return fetch(`/api/attributes/${id}`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: ATTRIBUTE_DELETE_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: ATTRIBUTE_DELETE_FAILURE, payload: data });
      }
    });
  };
}

// ----------------------

export function attributesDocEdit(data:any, id:string) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: DOC_EDIT_ATTRIBUTE_REQUEST });
    return fetch(`/api/documents/${id}`, {
      method: "PATCH",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data}),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: DOC_EDIT_ATTRIBUTE_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: DOC_EDIT_ATTRIBUTE_FAILURE, payload: data });
      }
    });
  };
}

export const DOC_EDIT_ATTRIBUTE_REQUEST = "EditDocAttr.Request";
export const DOC_EDIT_ATTRIBUTE_SUCCESS = "EditDocAttr.Success";
export const DOC_EDIT_ATTRIBUTE_FAILURE = "EditDocAttr.Failure";
export const DOC_EDIT_ATTRIBUTE_RESET = "EditDocAttr.Reset";
// ----------------------

export function attributesDocsEdit(data:any) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: DOCS_EDIT_ATTRIBUTE_REQUEST });
    return fetch(`/api/documents/`, {
      method: "PATCH",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data}),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: DOCS_EDIT_ATTRIBUTE_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: DOCS_EDIT_ATTRIBUTE_FAILURE, payload: data });
      }
    });
  };
}


export const DOCS_EDIT_ATTRIBUTE_REQUEST = "EditDocsAttr.Request";
export const DOCS_EDIT_ATTRIBUTE_SUCCESS = "EditDocsAttr.Success";
export const DOCS_EDIT_ATTRIBUTE_FAILURE = "EditDocsAttr.Failure";
export const DOCS_EDIT_ATTRIBUTE_RESET = "EditDocsAttr.Reset";

